import React from 'react';
import Hero from '../components/Hero';
import Resources from '../components/Resources';
import Services from '../components/Services';
import HowToWork from '../components/HowToWork';
import Projects from '../components/Projects';
import Products from '../components/Products';
import Network from '../components/Network';
import Facilities from '../components/Facilities';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <Resources />
      <HowToWork />
      <Projects />
      <Products />
      <Network />
      <Facilities />
    </>
  );
};

export { Home };
export default Home;
